import { ErrorItem } from '../../components/ErrorsPresenter/ErrorsPresenter';
import { ResourceType } from '../common/typings';

export interface UploadByLinkModalState {
    isVisible: boolean;
    isLoading?: boolean;
    editorId: string;
    value: string;
    errors: ErrorItem[];
    urlType: ResourceType;
}

export const URL_FORM_ERRORS_PATH = 'url';
export const GLOBAL_ERRORS_PATH = '';
